import { deleteCallIssueDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteCallIssueCallable = getCallable(deleteCallIssueDefinition);
